import React, { useState, useEffect, useContext } from 'react';

import './Switch.scss';

import intl from 'react-intl-universal';

import { ThemeContext } from '../../store/ThemeProvider';
import { alpha } from 'utils/color';

export interface ISwitch {
  value: boolean;
  onChange?: (val: boolean) => void;
  onText?: string;
  offText?: string;
}

const Switch = (props: ISwitch) => {
  const { value, onText, offText, onChange } = props;
  const { componentColor, mainColor, h1Color, h2Color } = useContext(
    ThemeContext
  );

  return (
    <div
      className={'switch ' + `status-${!!value ? 'on' : 'off'}`}
      style={{ backgroundColor: !!value ? mainColor : h2Color }}
      onClick={() => {
        if (onChange) {
          onChange(!value);
        }
      }}
    >
      <div className="text-on" style={{ color: alpha(componentColor, 1) }}>
        {onText || intl.get('On')}
      </div>
      <div className="anchor" style={{ background: alpha(componentColor, 1) }}></div>
      <div className="text-off" style={{ color: alpha(componentColor) }}>
        {offText || intl.get('Off')}
      </div>
    </div>
  );
};

export default Switch;
